import { Col, Container, Row } from 'react-bootstrap';

import LogoImage from '../../assets/images/sokoj-logo-latinica-sivi.png';
import Copyright from '../UI/Copyright';
import LoginForgottenPassword from './ForgottenPassword/LoginForgottenPassword';

const LoginFormWithImageWrapper = (props) => {
  const { title, styles, backToLoginLabel, loading } = props || {};

  return (
    <div className={`wrapper-fade-in-long ${styles['wrapper-background']}`}>
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className={`${styles['auth-page-content']}`}>
          <Container>
            <div className={`${styles['login-holder-container']}`}>
              <Row className="g-0">
                <Col
                  lg="5"
                  className={`${styles['login-form-image-holder']} position-relative`}
                >
                  <div className={`${styles['bg-overlay']}`}></div>
                  <div
                    className={`${styles['image-container']} p-lg-5 p-4 auth-one-bg h-100`}
                  ></div>
                </Col>
                <Col lg="7">
                  <div
                    className={`${styles['border-radius-custom']} p-lg-5 p-4 bg-white`}
                  >
                    <div className="text-center">
                      <img src={LogoImage} alt="" height="80" />
                      <h3 className="mt-2">{title}</h3>
                    </div>
                    {props.children}
                    <div className="mt-5 text-center">
                      {!backToLoginLabel && (
                        <LoginForgottenPassword loading={loading} />
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </div>
      <Copyright styles={styles} />
    </div>
  );
};

export default LoginFormWithImageWrapper;
